import { abortableFetch, useEventCallback } from '@eas/common-web';
import { TextNote } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditChallengedAactDialog() {
  const callApi = useEventCallback(
    (challengedActId: string, formData: TextNote, updateClosed = false) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/challenged-act/${challengedActId}${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(formData),
        }
      );
    }
  );

  return {
    callApi,
  };
}
